
export default class ColorUtils {

	static getLuminosidade(cor) {
		if (cor) {
			var r, g, b, lum;

			cor = cor.replace('#', '');

			r = parseInt(cor.substr(0, 2), 16);
			g = parseInt(cor.substr(2, 2), 16);
			b = parseInt(cor.substr(4, 2), 16);

			return ((r * 299) + (g * 587) + (b * 114)) / 1000;
		} else {
			return 255;
		}
	}

	static getCorFonte(corFundo) {
		return this.getLuminosidade(corFundo) > 128 ? '#000' : '#fff';
	}

	static getCorNome(hexadecimal) {
		const cor = [
			{ hexadecimal: '#b71c1c', nome: 'Vermelho Escuro / Red 900' },
			{ hexadecimal: '#880e4f', nome: 'Rosa Escuro / Pink 900' },
			{ hexadecimal: '#4a148c', nome: 'Roxo Profundo / Purple 900' },
			{ hexadecimal: '#311b92', nome: 'Índigo Profundo / Deep Indigo 900' },
			{ hexadecimal: '#1a237e', nome: 'Azul Índigo Escuro / Indigo 900' },
			{ hexadecimal: '#0d47a1', nome: 'Azul Royal Escuro / Blue 900' },
			{ hexadecimal: '#d32f2f', nome: 'Vermelho Forte / Red 700' },
			{ hexadecimal: '#c2185b', nome: 'Rosa Intenso / Pink 700' },
			{ hexadecimal: '#7b1fa2', nome: 'Roxo Intenso / Purple 700' },
			{ hexadecimal: '#512da8', nome: 'Roxo Médio / Deep Purple 700' },
			{ hexadecimal: '#303f9f', nome: 'Índigo Médio / Indigo 700' },
			{ hexadecimal: '#1976d2', nome: 'Azul Médio / Blue 700' },
			{ hexadecimal: '#f44336', nome: 'Vermelho (Padão) / Red 500' },
			{ hexadecimal: '#e91e63', nome: 'Rosa (Padrão) / Pink 500' },
			{ hexadecimal: '#9c27b0', nome: 'Roxo (Padrão) / Purple 500' },
			{ hexadecimal: '#673ab7', nome: 'Roxo Profundo (Padrão)' },
			{ hexadecimal: '#3f51b5', nome: 'Índigo (Padrão)' },
			{ hexadecimal: '#2196f3', nome: 'Azul (Padrão)' },
			{ hexadecimal: '#e57373', nome: 'Vermelho Claro / Red 300' },
			{ hexadecimal: '#f06292', nome: 'Rosa Claro / Pink 300' },
			{ hexadecimal: '#ba68c8', nome: 'Roxo Claro / Purple 300' },
			{ hexadecimal: '#9575cd', nome: 'Roxo Lavanda / Deep Purple 300' },
			{ hexadecimal: '#7986cb', nome: 'Índigo Claro / Indigo 300' },
			{ hexadecimal: '#64b5f6', nome: 'Azul Claro / Blue 300' },
			{ hexadecimal: '#ffcdd2', nome: 'Rosa Suave / Red 100' },
			{ hexadecimal: '#f8bbd0', nome: 'Rosa Algodão / Pink 100' },
			{ hexadecimal: '#e1bee7', nome: 'Lilás / Purple 100' },
			{ hexadecimal: '#d1c4e9', nome: 'Lilás Clara / Deep Purple 100' },
			{ hexadecimal: '#c5cae9', nome: 'Índigo Suave / Indigo 100' },
			{ hexadecimal: '#bbdefb', nome: 'Azul Suave / Blue 100' },
			{ hexadecimal: '#01579b', nome: 'Azul Petróleo Profundo' },
			{ hexadecimal: '#006064', nome: 'Verde Água Profundo' },
			{ hexadecimal: '#194d33', nome: 'Verde Selva Escuro' },
			{ hexadecimal: '#004d40', nome: 'Verde Pinheiro' },
			{ hexadecimal: '#33691e', nome: 'Verde Musgo' },
			{ hexadecimal: '#827717', nome: 'Verde Mostarda Escuro' },
			{ hexadecimal: '#0288d1', nome: 'Azul Celeste Forte / Light Blue 700' },
			{ hexadecimal: '#0097a7', nome: 'Ciano Forte / Cyan 700' },
			{ hexadecimal: '#00796b', nome: 'Verde Água Escuro / Teal 700' },
			{ hexadecimal: '#388e3c', nome: 'Verde Médio / Green 700' },
			{ hexadecimal: '#689f38', nome: 'Verde Folha' },
			{ hexadecimal: '#afb42b', nome: 'Verde Lima Escuro / Lime 700' },
			{ hexadecimal: '#03a9f4', nome: 'Azul Celeste / Light Blue 500' },
			{ hexadecimal: '#00bcd4', nome: 'Ciano / Cyan 500' },
			{ hexadecimal: '#009688', nome: 'Verde Água / Teal 500' },
			{ hexadecimal: '#4caf50', nome: 'Verde / Green 500' },
			{ hexadecimal: '#8bc34a', nome: 'Verde Lima / Light Green 500' },
			{ hexadecimal: '#cddc39', nome: 'Verde Amarelo / Lime 500' },
			{ hexadecimal: '#4fc3f7', nome: 'Azul Celeste Claro' },
			{ hexadecimal: '#4dd0e1', nome: 'Ciano Claro' },
			{ hexadecimal: '#4db6ac', nome: 'Verde Água Claro' },
			{ hexadecimal: '#81c784', nome: 'Verde Primavera' },
			{ hexadecimal: '#aed581', nome: 'Verde Lima Suave' },
			{ hexadecimal: '#dce775', nome: 'Lima Pastel' },
			{ hexadecimal: '#b3e5fc', nome: 'Azul Pastel' },
			{ hexadecimal: '#b2ebf2', nome: 'Ciano Pastel' },
			{ hexadecimal: '#b2dfdb', nome: 'Verde Água Pastel' },
			{ hexadecimal: '#c8e6c9', nome: 'Verde Menta Claro' },
			{ hexadecimal: '#dcedc8', nome: 'Verde Chá Suave' },
			{ hexadecimal: '#f0f4c3', nome: 'Lima Creme' },
			{ hexadecimal: '#f57f17', nome: 'Amarelo Torrado / Amber 900' },
			{ hexadecimal: '#ff6f00', nome: 'Amarelo Laranja Forte / Amber 800' },
			{ hexadecimal: '#e65100', nome: 'Laranja Torrado / Orange 900' },
			{ hexadecimal: '#bf360c', nome: 'Laranja Telha Escuro / Deep Orange 900 '},
			{ hexadecimal: '#3e2723', nome: 'Marrom Café' },
			{ hexadecimal: '#263238', nome: 'Azul Grafite / Blue Grey 900' },
			{ hexadecimal: '#fbc02d', nome: 'Amarelo Ouro / Yellow 700' },
			{ hexadecimal: '#ffa000', nome: 'Amarelo Queimado / Amber 700' },
			{ hexadecimal: '#f57c00', nome: 'Laranja Forte / Orange 700' },
			{ hexadecimal: '#e64a19', nome: 'Laranja Avermelhado / Deep Orange 700' },
			{ hexadecimal: '#5d4037', nome: 'Marrom Madeirado' },
			{ hexadecimal: '#455a64', nome: 'Azul Ardósia / Blue Grey 700' },
			{ hexadecimal: '#ffeb3b', nome: 'Amarelo / Yellow 500' },
			{ hexadecimal: '#ffc107', nome: 'Amarelo Âmbar / Amber 500' },
			{ hexadecimal: '#ff9800', nome: 'Laranja / Orange 500' },
			{ hexadecimal: '#ff5722', nome: 'Laranja Avermelhado / Deep Orange 500' },
			{ hexadecimal: '#795548', nome: 'Marrom Terra' },
			{ hexadecimal: '#607d8b', nome: 'Cinza Azulado / Blue Grey 500' },
			{ hexadecimal: '#fff176', nome: 'Amarelo Claro' },
			{ hexadecimal: '#ffd54f', nome: 'Âmbar Claro' },
			{ hexadecimal: '#ffb74d', nome: 'Laranja Claro' },
			{ hexadecimal: '#ff8a65', nome: 'Laranja Coral' },
			{ hexadecimal: '#a1887f', nome: 'Marrom Suave' },
			{ hexadecimal: '#90a4ae', nome: 'Azul Cinzento' },
			{ hexadecimal: '#fff9c4', nome: 'Creme Amarelado' },
			{ hexadecimal: '#ffecb3', nome: 'Creme Âmbar' },
			{ hexadecimal: '#ffe0b2', nome: 'Pêssego Claro' },
			{ hexadecimal: '#ffccbc', nome: 'Pêssego Suave' },
			{ hexadecimal: '#d7ccc8', nome: 'Marrom Cinza Claro' },
			{ hexadecimal: '#cfd8dc', nome: 'Cinza Azul Claro' },
			{ hexadecimal: '#000000', nome: 'Preto' },
			{ hexadecimal: '#525252', nome: 'Cinza Escuro' },
			{ hexadecimal: '#969696', nome: 'Cinza Médio' },
			{ hexadecimal: '#d9d9d9', nome: 'Cinza Claro' },
			{ hexadecimal: '#ffffff', nome: 'Branco' }
		].filter(item => item.hexadecimal == hexadecimal)[0];

		return cor ? cor.nome : '';
	}

}
